import React from "react";
import "./style.scss";
import { useGethomesectionsQuery } from "../../../../services/homeAPI";
import Loader from "../../fullPageLoader";
import { useGetColorThemeQuery } from "../../../../services/commonAPI";

function Index() {
  const { data, error, isLoading } = useGethomesectionsQuery();

  const { data: colorthemeData } = useGetColorThemeQuery();

  if (isLoading) return <Loader />;
  if (error) return <p>Failed to load data</p>;

  const featuredCategories =
    data?.data?.filter(
      (item) => item.product_source === "featured_category" && item.is_active
    ) || [];
  console.log("featuredCategories", featuredCategories);

  return (
    <>
      {featuredCategories?.length > 0 && (
        <section className="new-arrivals">
          <div className="container">
            {featuredCategories[0]?.is_small_heading_active === true && (
              <h5
                style={{
                  color:
                    colorthemeData?.color_themes?.[0]?.text_color_one ||
                    "#a5a5a5",
                }}
                data-aos="fade-up"
              >
                {featuredCategories[0]?.small_heading}
              </h5>
            )}
            {featuredCategories[0]?.is_title_active === true && (
              <h4
                style={{
                  color:
                    colorthemeData?.color_themes?.[0]?.heading_color || "#000",
                }}
                data-aos="fade-up"
              >
                {featuredCategories[0]?.title}
              </h4>
            )}
            {featuredCategories[0]?.is_description_active === true && (
              <p
                className="sub-text"
                style={{
                  color:
                    colorthemeData?.color_themes?.[0]?.paragraph_color ||
                    "##767676",
                }}
                data-aos="fade-up"
              >
                {featuredCategories?.[0]?.description}
              </p>
            )}
            <div className="new-arrival-list">
              <div className="row justify-content-center" data-aos="fade-up"> 
                {featuredCategories[0]?.categories
                  ?.slice(-3)
                  .map((category) => (
                    <div className="col-md-4 col-sm-12 col-lg-4">
                      <div className="product-img">

                      <img src={category.category_image} alt="category" loading="lazy"/>
                      </div>
                      <p
                        className="product-name"
                        style={{
                          color:
                            colorthemeData?.color_themes?.[0]?.heading_color ||
                            "#000",
                        }}
                        data-aos="fade-up"
                      >
                        {category.category_name}
                      </p>
                      <p
                        className="product-count"
                        style={{
                          color:
                            colorthemeData?.color_themes?.[0]?.text_color_one,
                        }}
                        data-aos="fade-up"
                      >
                        {category.product_count} products
                      </p>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
}

export default Index;
